import React, { useState, useEffect } from 'react';
import { handleErrorToast } from '../../../../shared/Functions';
import {  TokensVService } from '../../../../../services/V2/gozer';

export function CCiframe({ billingAccountId, failureCallback, isSaved, setTokenId }) {
    const [count, setCount] = useState<number>(0);
    const [retrieval, setRetrieval] = useState<any>(null);

    useEffect(() => {
        TokensVService.tokensVGenerateUrlForm(billingAccountId, { isSaved })
            .then(t => {
                setRetrieval(t);
            })
            .catch(err => failureCallback(handleErrorToast(err)));
    }, [billingAccountId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(count === 2) {
            checkToken();
        }
    }, [count])// eslint-disable-line react-hooks/exhaustive-deps

    const checkToken = () => {
        TokensVService.tokensVGetStatusById(billingAccountId, retrieval.id)
            .then(t => {
                if(t){
                    setTokenId(t.id);                   
                } else {
                    setTimeout(checkToken, 1000);
                }
            })
            .catch(err => failureCallback(handleErrorToast(err)));
    }

    if(!retrieval) return null;

    return (
        <iframe title="cc-token-creation" onLoad={() => setCount(count + 1)} src={`${retrieval.url}&TextColor=000000&HideReset=1&HideAddress=1&HideCity=1&HideState=1&SaveButtonText=Continue`} style={{ width: "500px", height: "700px", border: "none" }} />
    );
}